const DAY_NAMES = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const DEFAULT_HOURS = [
  { day: 0, day_name: 'Lundi', is_closed: true, slots: [] },
  { day: 1, day_name: 'Mardi', is_closed: false, slots: [{ start: '11:30', end: '14:30' }, { start: '19:00', end: '22:30' }] },
  { day: 2, day_name: 'Mercredi', is_closed: false, slots: [{ start: '11:30', end: '14:30' }, { start: '19:00', end: '22:30' }] },
  { day: 3, day_name: 'Jeudi', is_closed: false, slots: [{ start: '11:30', end: '14:30' }, { start: '19:00', end: '22:30' }] },
  { day: 4, day_name: 'Vendredi', is_closed: false, slots: [{ start: '11:30', end: '14:30' }, { start: '19:00', end: '23:00' }] },
  { day: 5, day_name: 'Samedi', is_closed: false, slots: [{ start: '11:30', end: '14:30' }, { start: '19:00', end: '23:00' }] },
  { day: 6, day_name: 'Dimanche', is_closed: true, slots: [] },
];

/**
 * Enrich backend hours with day_name and defaults
 * Backend returns: { day: 0, is_closed: true, slots: [{start, end}] }
 */
export function enrichHours(apiHours) {
  if (!apiHours || apiHours.length === 0) return DEFAULT_HOURS;
  return apiHours.map(h => ({
    ...h,
    day_name: DAY_NAMES[h.day] || `Jour ${h.day}`,
    slots: (h.slots || []).map(s => ({
      start: s.start || s.open || '',
      end: s.end || s.close || '',
    })),
  }));
}

/**
 * Format a single slot for display: "11h30–14h30"
 */
function formatSlot(slot) {
  const s = (slot.start || '').replace(':', 'h');
  const e = (slot.end || '').replace(':', 'h');
  return `${s}–${e}`;
}

/**
 * Format a day's slots for display: "11h30–14h30 / 19h–22h30"
 */
export function formatDaySlots(slots) {
  if (!slots || slots.length === 0) return '';
  return slots.map(formatSlot).join(' / ');
}

/**
 * Generate a short summary for footer: "Mar–Sam 11h30–14h30 / 19h–22h30"
 */
export function formatHoursSummary(hours) {
  const enriched = enrichHours(hours);
  const openDays = enriched.filter(h => !h.is_closed);
  if (openDays.length === 0) return 'Horaires non définis';

  // Find consecutive open day ranges
  const ranges = [];
  let rangeStart = null;
  let rangeEnd = null;

  for (let i = 0; i < 7; i++) {
    const day = enriched.find(h => h.day === i);
    if (day && !day.is_closed) {
      if (rangeStart === null) rangeStart = i;
      rangeEnd = i;
    } else {
      if (rangeStart !== null) {
        ranges.push({ start: rangeStart, end: rangeEnd });
        rangeStart = null;
        rangeEnd = null;
      }
    }
  }
  if (rangeStart !== null) ranges.push({ start: rangeStart, end: rangeEnd });

  // Use the longest range for summary
  const longest = ranges.sort((a, b) => (b.end - b.start) - (a.end - a.start))[0];
  if (!longest) return 'Horaires non définis';

  const startName = DAY_NAMES[longest.start].slice(0, 3);
  const endName = DAY_NAMES[longest.end].slice(0, 3);
  const refDay = enriched.find(h => h.day === longest.start);
  const slotsStr = formatDaySlots(refDay.slots);

  if (longest.start === longest.end) return `${startName} ${slotsStr}`;
  return `${startName}–${endName} ${slotsStr}`;
}

export { DAY_NAMES, DEFAULT_HOURS };
